var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66659 8.00016C2.66659 5.03502 5.03478 2.66683 7.99992 2.66683C10.9651 2.66683 13.3333 5.03502 13.3333 8.00016V8.66683H11.9999C10.8984 8.66683 9.99992 9.56531 9.99992 10.6668V12.6668C9.99992 13.7684 10.8984 14.6668 11.9999 14.6668H12.6666C13.7681 14.6668 14.6666 13.7684 14.6666 12.6668V8.00016C14.6666 4.29864 11.7014 1.3335 7.99992 1.3335C4.2984 1.3335 1.33325 4.29864 1.33325 8.00016V12.6668C1.33325 13.7684 2.23173 14.6668 3.33325 14.6668H3.99992C5.10144 14.6668 5.99992 13.7684 5.99992 12.6668V10.6668C5.99992 9.56531 5.10144 8.66683 3.99992 8.66683H2.66659V8.00016ZM2.66659 10.0002V12.6668C2.66659 13.032 2.96811 13.3335 3.33325 13.3335H3.99992C4.36506 13.3335 4.66659 13.032 4.66659 12.6668V10.6668C4.66659 10.3017 4.36506 10.0002 3.99992 10.0002H2.66659ZM13.3333 10.0002H11.9999C11.6348 10.0002 11.3333 10.3017 11.3333 10.6668V12.6668C11.3333 13.032 11.6348 13.3335 11.9999 13.3335H12.6666C13.0317 13.3335 13.3333 13.032 13.3333 12.6668V10.0002Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.10574,
    y1: -3.53423,
    x2: 7.99992,
    y2: 14.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.278ef851.svg";
export { ForwardRef as ReactComponent };